import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { AddProductComponent } from '../../admin/sub-admin/add-product/add-product.component';
import moment from 'moment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-admin-market-blog',
  templateUrl: './admin-market-blog.component.html',
  styleUrls: ['./admin-market-blog.component.scss'],
})
export class AdminMarketBlogComponent implements OnInit {
  @ViewChild('AddShop') addProductComponent: AddProductComponent;
  @ViewChild('dropdown') dropdown: ElementRef;
  private modalRef: any;
  constructor(
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService
  ) { }

  bottomImagesForm: FormGroup;
  // Editor = ClassicEditor;
  EditorData: any = ``;
  EditorConfig = {
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        // 'insertTable',
        // 'imageUpload',
        // '|',
        'undo',
        'redo',
      ],
    },
  };
  ckEditorText: string = '';
  baseUrlImgae = environment.ImageUrl;
  blogs: any = [];
  blogImageUrl: string = '';
  blogPathImage: any = null;
  blogImageSelected: any = null;
  categories: any = ['SG News', 'Promotions', 'Funny', 'Business'];

  ngOnInit(): void {
    this.getBlogs();
  }

  get bottomBannerControl() {
    return this.bottomImagesForm.controls;
  }

  getBlogs() {
    this.auth.get_bottom_banner({
      isAdmin: true
    }).subscribe(
      (response: any) => {
        this.blogs = response.body;
      },
      (e) => {
        this.toastr.error(e.error.message);
      }
    );
  }
  openModalBlogForm(modal: any, item: any = { text: '' }) {
    this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
    });

    this.ckEditorText = item?.text;
    this.blogImageUrl =
      item?.image != null ? `${this.baseUrlImgae}${item.image}` : '';
    this.bottomImagesForm = this.fb.group({
      id: [item?.id, []],
      banner: ['', [Validators.required]],
      title: [item?.title, [Validators.required]],
      author: [item?.author, [Validators.required]],
      category: [item?.category, [Validators.required]],
    });
  }

  editBlog(modal: any, item: any) {
    this.openModalBlogForm(modal, item);
  }

  onBottomBannerSelected(files: any, event: any) {
    this.blogImageUrl = '';
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    const file = event.target.files;
    if (file && file[0]) {
      if (file[0].size > 2097152) {
        this.toastr.error('Max File size must be Less than 2MB!');
        return;
      }

      const reader = new FileReader();
      reader.onload = (event: any) => {
        this.blogImageUrl = event.target.result;
      };
      reader.readAsDataURL(file[0]);
    }

    this.blogPathImage = files;
    this.blogImageSelected = <File>files[0];
    // console.log(this.selectedBanner,'--------------------asd')
  }

  addBottomBanner() {
    // alert()
    // this.submitted = true;

    const id = this.bottomImagesForm.value.id;

    if (this.bottomImagesForm.invalid && id == null) {
      return;
    }

    this.spinner.show();

    let formData = new FormData();
    formData.append('title', this.bottomImagesForm.value.title);
    formData.append('text', this.ckEditorText);
    // formData.append('url', this.bottomImagesForm.value.url);
    formData.append('author', this.bottomImagesForm.value.author);
    formData.append('category', this.bottomImagesForm.value.category);
    formData.append('image', this.blogImageSelected);
    formData.append('adminId', '0');
    formData.append('isAdmin', '1');

    let method = 'add_bottom_banner';
    if (id != null) {
      method = 'edit_bottom_banner';
      formData.append('bottomBannerId', id);
    }

    this.local.alertLoading({});

    this.auth[method](formData).subscribe(
      (response: any) => {
        Swal.close();
        // console.log(response,'--------------------------------------')
        this.spinner.hide();
        this.modalService.dismissAll();
        this.getBlogs();
        // this.bottom_banner_image_url_show = 0;
        this.toastr.success(response.message);
      },
      (e) => {
        Swal.close();
        this.toastr.error(e.error.message);
      }
    );
  }

  deleteBlog(id: number) {
    this.local.alertConfirm({}).then((resp: any) => {
      if (resp.isConfirmed) {
        this.auth.delete_bottom_banner({ bottomBannerId: id }).subscribe(
          (response: any) => {
            // console.log(response,'--------------------------------------')
            this.spinner.hide();
            this.modalService.dismissAll();
            this.getBlogs();
            // this.bottom_banner_image_url_show = 0;
            this.toastr.success(response.message);
          },
          (e) => {
            this.toastr.error(e.error.message);
          }
        );
      }
    });
  }

  onEditorChange(event: any) {
    this.ckEditorText = event.editor.getData();
  }

  convertDate(value: number) {
    return moment.unix(value).format('MMMM D, YYYY');
  }

  public selMenu = 'Blog&Ads';
  public selectMenu(menu: string) {
    this.selMenu = menu;
  }
}
